// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__lsqVn","inner":"Footer_inner__3t30L"};